/* @flow */
/**
 * Language strings that will be properly localized and pluralized eventually
 */

import Group from 'entities/Group';
import { EVERYONE } from 'utils/roleHelpers';

export function titleForSection(sectionKey: string, count: number = 0) {
  switch (sectionKey) {
    case 'districts':
      return count > 1 ? 'Districts' : 'District';
    case 'schools':
      return count > 1 ? 'Schools' : 'School';
    case 'classes-owned':
      return 'Classes owned';
    case 'classes-subscribed':
      return 'Classes joined';
    default:
      return '???';
  }
}

export function membershipDescriptionFor(group: Group, role: ?string) {
  let size;
  if (role && role !== EVERYONE) {
    const roleObj = group.getRoles().find(r => r.role === role);
    size = roleObj ? roleObj.count : 0;
  } else {
    size = group.getMembershipsCount();
  }
  let membersDescription = 'participant';

  if (group.isStaffClass()) {
    membersDescription = 'member';
  }
  if (role && role !== EVERYONE) {
    membersDescription = role;
  }
  if (size !== 1) {
    membersDescription += 's';
  }
  return `${size} ${membersDescription}`;
}

export function memberTypeFor(group: Group) {
  if (group.isStaffClass()) {
    return 'members';
  } else {
    return 'participants';
  }
}



// WEBPACK FOOTER //
// ./src/groups/lib/groupDisplay.js